module.exports = __webpack_public_path__ + "media/country_flags/eh-78c9f236.png";